import React from "react";
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import GridTable, { fldInfsProps } from "@/js/common/ui/GridTable";
import Modal from "@/js/common/ui/modal/Modal";
import AdminGridStyle from "@/js/common/ui/style/AdminGridStyle";
import Util from "@/js/common/Util";
import SelectBox from "@/js/common/ui/input/SelectBox";
import DialogTitleBar from "../../common/DialogTitleBar";
import SysOgnzAuthrtSaveDialog from "./dialog/SysOgnzAuthrtSaveDialog";

/**
 * SysOgnzAuthrtMng.tsx
 * ------------------------------------------------------------
 */

const SysOgnzAuthrtMng = () => {

  // 검색 조건
  const [upOgnzCd, setUpOgnzCd] = React.useState<string>("");
  const [ognzCd, setOgnzCd] = React.useState<string>("");
  const [sysAuthrtSeCd, setSysAuthrtSeCd] = React.useState<string>("");

  const [dataArr, setDataArr] = React.useState<any[]>([]);
  const [callTime, setCallTime] = React.useState<Date>(new Date());

  // 모달
  const [modalOpen, setModalOpen] = React.useState<boolean>(false);
  const [pkOgnzCd, setPkOgnzCd] = React.useState<string>("");
  const [pkSysAuthrtSeCd, setPkSysAuthrtSeCd] = React.useState<string>("");

  // GridTable 컬럼
  const fldInfs: fldInfsProps[] = [
    { type: "text", fldNm: "upOgnzNm", width: 140, headAlign: "center", dataAlign: "center", label: "본부" },
    { type: "text", fldNm: "ognzNm", width: 140, headAlign: "center", dataAlign: "center", label: "지부" },
    { type: "text", fldNm: "sysAuthrtSeNm", width: 160, headAlign: "center", dataAlign: "center", label: "시스템 권한 구분" },
    { type: "text", fldNm: "sysAuthrtYn", width: 100, headAlign: "center", dataAlign: "center", label: "권한 여부" },
    { type: "text", fldNm: "sysEvdncUseYn", width: 100, headAlign: "center", dataAlign: "center", label: "증빙서류 사용여부" },
    { type: "date", fldNm: "bgngYmd", width: 110, headAlign: "center", dataAlign: "center", label: "시작일" },
    { type: "date", fldNm: "endYmd", width: 110, headAlign: "center", dataAlign: "center", label: "종료일" },
    { type: "text", fldNm: "mdfcnDt", width: 160, headAlign: "center", dataAlign: "center", label: "수정일시" },
    { type: "text", fldNm: "mdfrNm", width: 120, headAlign: "center", dataAlign: "center", label: "수정자" },
  ];

  // 조회
  React.useEffect(() => {
    AppContext.showSpinner();
    Axios.dataAccess({
      url: "system/sys/ognz/authrt/select-ognz-authrt-list.do",
      methodType: "post",
      paramType: "json",
      paramData: {
        upOgnzCd: upOgnzCd,
        ognzCd: ognzCd,
        sysAuthrtSeCd: sysAuthrtSeCd,
      },
      onSuccessFn: (res: any) => {
        setDataArr(res.result.list);
        AppContext.hideSpinner();
      },
    });
  }, [callTime, upOgnzCd, ognzCd, sysAuthrtSeCd]);

  const openNew = () => {
    setPkOgnzCd("");
    setPkSysAuthrtSeCd("");
    setModalOpen(true);
  };

  const openEdit = (item: any) => {
    setPkOgnzCd(item.ognzCd);
    setPkSysAuthrtSeCd(item.sysAuthrtSeCd);
    setModalOpen(true);
  };

  return (
    <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">
      {/* 타이틀 */}
      <div className="mt5">
        <span className="posR dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">조직 시스템 권한 관리</span>
        <div className="bdt3 bdc007bff pb10"></div>
      </div>

      {/* 검색 조건 */}
      <div className="bd1 bdcDDDDDD p20 mb10 bdrd6 bgcFAFAFA">
        <div className="dpFlx aiC gap14 jcSb">
          <div className="dpFlx aiC gap14 flxWrap">
            {/* 본부 */}
            <div className="dpFlx aiC">
              <span className="w60 fm-c fs15 fc333333 ls1 taL">본부</span>
              <SelectBox
                value={upOgnzCd}
                width={170}
                height={36}
                fontSize={14}
                fontFamily="fm-c"
                color="#333"
                letterSpacing={-1}
                borderColor="#ddd"
                borderOnColor="#222"
                borderRadius={2}
                background="#fff"
                codeArray={[{ code: "", name: "전체" }].concat(Util.getUpOrgCodeArray("01"))}
                placeholder="전체"
                paddingRight={8}
                onChangeFunc={(v: string) => {
                  setUpOgnzCd(v);
                  setOgnzCd("");
                }}
              />
            </div>

            {/* 지부 */}
            <div className="dpFlx aiC">
              <span className="w60 fm-c fs15 fc333333 ls1 taL">지부</span>
              <SelectBox
                value={ognzCd}
                width={170}
                height={36}
                fontSize={14}
                fontFamily="fm-c"
                color="#333"
                letterSpacing={-1}
                borderColor="#ddd"
                borderOnColor="#222"
                borderRadius={2}
                background="#fff"
                codeArray={[{ code: "", name: "전체" }].concat(Util.getDownOrgCodeArray(upOgnzCd))}
                placeholder="전체"
                paddingRight={8}
                onChangeFunc={(v: string) => setOgnzCd(v)}
              />
            </div>

            {/* 시스템 권한 구분 */}
            <div className="dpFlx aiC">
              <span className="w120 fm-c fs15 fc333333 ls1 taL">시스템 권한 구분</span>
              <SelectBox
                value={sysAuthrtSeCd}
                width={200}
                height={36}
                fontSize={14}
                fontFamily="fm-c"
                color="#333"
                letterSpacing={-1}
                borderColor="#ddd"
                borderOnColor="#222"
                borderRadius={2}
                background="#fff"
                codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("SYS_AUTHRT_SE_CD"))}
                placeholder="전체"
                paddingRight={8}
                onChangeFunc={(v: string) => setSysAuthrtSeCd(v)}
              />
            </div>
          </div>

          {/* 버튼 */}
          <div className="dpFlx aiC gap10">
            <Button
              width={75}
              height={40}
              fontFamily="fm-b"
              fontSize={16}
              letterSpacing={-1}
              variant="styInitBtn"
              borderRadius={6}
              buttonClass="dpFlx aiC jcC"
              buttonName="초기화"
              onClickFunc={ () => {
                setUpOgnzCd("");
                setOgnzCd("");
                setSysAuthrtSeCd("");
              }}
            />
          </div>
        </div>
      </div>

      {/* 목록 헤더(좌 타이틀 / 우 등록) */}
      <div className="dpFlx aiC jcSb mb10 h44">
        <div className="fm-b fs16 fc007bff ls1 fw700">
          <span>권한 목록</span>
        </div>

        <Button
          width={110}
          height={40}
          fontFamily="fm-b"
          fontSize={16}
          letterSpacing={-1}
          color="#fff"
          backgroundColor="#28a745"
          borderRadius={6}
          buttonClass="dpFlx aiC jcC"
          buttonName="권한 등록"
          onClickFunc={openNew}
        />
      </div>

      {/* 그리드 */}
      <GridTable
        tableInfo={{
          tableHeadVsb: true,
          styleType: AdminGridStyle,
          fldInfs: fldInfs,
          dataArr: dataArr,
          maxRowNums: [10, 20, 30],
          theadTrHeight: 40,
          tbodyTrHeight: 35,
          paginateClass: "pt10",
          paginateStyle: {
            buttonOnColor: AppContext.boardThemeColor,
            buttonWidth: 22,
            buttonHeight: 24,
            buttonMarginLeft: 1,
            buttonMarginRight: 1,
            fontSize: 13,
            color: "#666666",
            letterSpacing: -0.8,
            fontFamily: "Pretendard-Regular",
            borderRadius: 3,
          },
          footerVsb: true,
          rowClickFunc: (item: any) => openEdit(item),
        }}
      />

      {/* 모달 */}
      <Modal
        modalOpen={modalOpen}
        dim={true}
        visible={true}
        titleEl={
          <DialogTitleBar
            title={Util.isEmpty(pkOgnzCd) ? "권한 등록" : "권한 상세/수정"}
            backgroundColor={AppContext.themeColor}
          />
        }
        onCloseFunc={() => {
          setModalOpen(false);
          setPkOgnzCd("");
          setPkSysAuthrtSeCd("");
        }}
      >
        <div>
          <SysOgnzAuthrtSaveDialog
            ognzCd={pkOgnzCd}
            sysAuthrtSeCd={pkSysAuthrtSeCd}
            setModalOpen={setModalOpen}
            setCallTime={setCallTime}
            listData={dataArr}
          />
        </div>
      </Modal>
    </div>
  );
};

export default SysOgnzAuthrtMng;
